import { apiGet } from '../../api'

export const get_groups = () => {
  return apiGet({
    endpoint: 'application/get_groups'
  })
}
